import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { connect } from "react-redux";

import {
  toValidatePin,
  toValidatePassword,
  toValidateConfirmPassword,
} from "../../../../utils/validations/checkValidation";
import {
  ChangePinChangePass,
  HeadingContainer,
  ContainerRow,
  ComponentDivSty,
  InfoDivStyle,
} from "./ChangePassword.styles.component";
import Button from "../../../../components/Button/Button.component";
import ModalComponent from "../../../../components/ModalPopupComponent/ModalPopup.component";
import SlideButton from "../../../../components/InfoDivComponent/InfoDiv.component";
import InputField from "../../../../components/InputFieldComponent/InputPasswordPin.component";
import PasswordErrorMessages from "../../../../components/password/PasswordErrorMessages";
import { getPasswordPolicy } from "../../../../redux/accounts/action";
import { generatePasswordRegex } from "../../../../utils/validations/utilities";
function PasswordModal({
  id,
  showModal,
  setModal,
  changePassword,
  isPin,
  isLoadingPasswordChange,
  setLoadingPasswordChange,
  passwordPolicy,
  getPasswordPolicy,
  isSuperAdmin,
  userAccountId,
}) {
  const [passwordForm, setPasswordForm] = useState({ userId: id });
  const [show, setShow] = useState({});
  const [validated, setValidated] = useState(false);
  const [passwordRegex, setPasswordRegex] = useState({});

  const { t } = useTranslation();

  useEffect(() => {
    setValidated(false);
    setLoadingPasswordChange(false);
    setPasswordForm({ userId: id });
    setIsError(false);
  }, [showModal]);

  useEffect(() => {
    if (!passwordPolicy?.minLength) {
      getPasswordPolicy(userAccountId);
    }
  }, []);

  useEffect(() => {
    if (passwordPolicy) {
      const passwordRegex = generatePasswordRegex(passwordPolicy);
      setPasswordRegex(passwordRegex);
    }
  }, [passwordPolicy]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoadingPasswordChange(true);
    setValidated(true);

    let isInvalidPassword = isPin
      ? toValidatePin(passwordForm.pin)
      : toValidatePassword(passwordForm.newPassword, passwordRegex);
    setIsError(true);
    let isInvalidVerifyPassword =
      !isPin && toValidateConfirmPassword(passwordForm.newPassword, passwordForm.verifyPassword);

    let isInvalidPinLength = isPin && passwordForm.pin.trim().length < 4;

    if (isInvalidPassword || isInvalidVerifyPassword || isInvalidPinLength) {
      e.preventDefault();
      e.stopPropagation();
      setIsError(true);
      setLoadingPasswordChange(false);
      return;
    } else {
      setIsError(false);
    }

    changePassword(e, passwordForm);
  };

  const [isError, setIsError] = useState(false);

  /*   const ComponentDiv = () => {
    console.log("ComponentDiv--------", isPin);
    return <ComponentDivSty isError={isError}>{isPin ? t("PIN_RULES") : "tets"}</ComponentDivSty>;
  }; */

  return (
    <>
      <ModalComponent
        style={{ textAlign: "center" }}
        show={showModal}
        title={isPin ? <Trans>Edit User Details</Trans> : <Trans>Edit User Details</Trans>}
        size="lg"
        handleClose={() => setModal(false)}
        withHeader={true}
      >
        <ChangePinChangePass>
          <HeadingContainer>
            {isPin ? <Trans>Change pin</Trans> : <Trans>Change password</Trans>}
          </HeadingContainer>
          <Form noValidate id="changePassowrdForm" onSubmit={handleSubmit}>
            {/* modal body starts */}
            <ContainerRow>
              <Row className="p4">
                <Col md={6} className="mb-2">
                  <InputField
                    required
                    label={isPin ? t("New PIN") : t("New Password")}
                    name={isPin ? "pin" : "password"}
                    minLength={isPin ? "4" : "8"}
                    maxLength={isPin ? "32" : "64"}
                    type={isPin ? "text" : show.password ? "text" : "password"}
                    placeholder={isPin ? t("Enter New Pin") : t("Enter New Password")}
                    onChange={(e) =>
                      setPasswordForm({
                        ...passwordForm,
                        [isPin ? "pin" : "newPassword"]: e.target.value,
                      })
                    }
                    isError={
                      validated &&
                      (isPin
                        ? validated && toValidatePin(passwordForm.pin)
                        : validated && toValidatePassword(passwordForm.newPassword, passwordRegex))
                    }
                    errorMessage={validated && (isPin ? validated && toValidatePin(passwordForm.pin) : null)}
                    autocomplete="one-time-code"
                  />
                </Col>

                <Col md={6} className="mb-2">
                  {!isPin && (
                    <InputField
                      name="passwordVerification"
                      label="Confirm Password"
                      required
                      minLength={8}
                      type="password"
                      placeholder={t("Confirm new password")}
                      autocomplete="one-time-code"
                      onChange={(e) =>
                        setPasswordForm({
                          ...passwordForm,
                          verifyPassword: e.target.value,
                        })
                      }
                      isError={
                        validated &&
                        toValidateConfirmPassword(passwordForm.newPassword, passwordForm.verifyPassword)
                      }
                      errorMessage={
                        validated &&
                        toValidateConfirmPassword(passwordForm.newPassword, passwordForm.verifyPassword)
                      }
                    />
                  )}
                </Col>

                <Col md={12} className="mt-4">
                  <InfoDivStyle>
                    <SlideButton
                      buttonName={isPin ? "Pin Rules" : "Password Rules"}
                      divContent={<></>}
                      iconName="information-tooltip"
                      isOpen="false"
                    />
                  </InfoDivStyle>
                </Col>
              </Row>
              <ComponentDivSty>
                {isPin ? (
                  t("PIN_RULES")
                ) : (
                  <PasswordErrorMessages hideIcon={true} isError={isError} userAccountId={userAccountId} />
                )}
              </ComponentDivSty>
            </ContainerRow>
            <div className="text-right">
              <Button
                iconClass="save"
                form="changePassowrdForm"
                // disabled={isPin ? !passwordForm?.pin?.trim() : !passwordForm?.newPassword?.trim()}
                label={
                  isLoadingPasswordChange ? (
                    <div className="spinner-border spinner-border-sm" title="Save" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    t("Save")
                  )
                }
                title="save"
                showIcon
                buttonType="save"
                disabled={
                  isPin
                    ? !passwordForm?.pin?.trim()
                    : !passwordForm?.newPassword?.trim() || !passwordForm?.verifyPassword?.trim()
                }
              />
            </div>
          </Form>
        </ChangePinChangePass>
      </ModalComponent>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    passwordPolicy: state?.accounts?.passwordPolicy,
    isSuperAdmin: state?.user?.isSuperAdmin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getPasswordPolicy: () => dispatch(getPasswordPolicy()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordModal);
